import React from 'react';
const Footer = () => (
	<>
		<footer id='footer'>
			<div className='footer-top'>
				<div className='container'>
					<div className='row'>
						<div className='col-lg-3 col-md-6 footer-info'>
							<h3>Aluzinc Panda Mabati LTD</h3>
							<p>
								For quality roofing materials and services. We supply our
								materials and offer our services country-wide. Free delivery
								country-wide.
							</p>
						</div>

						<div className='col-lg-3 col-md-6 footer-links'>
							<h4>Useful Links</h4>
							<ul>
								<li>
									<i className='ion-ios-arrow-right'></i> <a href='#'>Home</a>
								</li>
								<li>
									<i className='ion-ios-arrow-right'></i>{' '}
									<a href='#'>About us</a>
								</li>
								<li>
									<i className='ion-ios-arrow-right'></i>{' '}
									<a href='#'>Services</a>
								</li>
								<li>
									<i className='ion-ios-arrow-right'></i>{' '}
									<a href='#'>Terms of service</a>
								</li>
								<li>
									<i className='ion-ios-arrow-right'></i>{' '}
									<a href='#'>Privacy policy</a>
								</li>
							</ul>
						</div>

						<div className='col-lg-3 col-md-6 footer-contact'>
							<h4>Contact Us</h4>
							<p>
								<br />
								Nairobi
								<br />
								Kenya <br />
								<strong>Phone:</strong> +254 724758212
								<br />
								<strong>Email:</strong> support@aluzinc_ltpandamabati.co.ke
								<br />
							</p>

							<div className='social-links'>
								<a href='#' className='twitter'>
									<i className='fa fa-twitter'></i>
								</a>
								<a href='#' className='facebook'>
									<i className='fa fa-facebook'></i>
								</a>
								<a href='#' className='instagram'>
									<i className='fa fa-instagram'></i>
								</a>
								<a href='#' className='google-plus'>
									<i className='fa fa-google-plus'></i>
								</a>
								<a href='#' className='linkedin'>
									<i className='fa fa-linkedin'></i>
								</a>
							</div>
						</div>

						<div className='col-lg-3 col-md-6 footer-newsletter'>
							<h4>Our Newsletter</h4>
							<p>
								Enter your email to subscribe to our newsletter, so you won't
								miss any update from us
							</p>
							<form action='' method='post'>
								<input type='email' name='email' />
								<input type='submit' value='Subscribe' />
							</form>
						</div>
					</div>
				</div>
			</div>

			<div className='container'>
				<div className='copyright'>
					&copy; Copyright <strong>Aluzinc</strong>. All Rights Reserved
				</div>
				<div className='credits'>
					Developed by <a href=''>webtechub: 0785608538</a>
				</div>
			</div>
		</footer>

		<a href='#' className='back-to-top'>
			<i className='fa fa-chevron-up'></i>
		</a>
	</>
);
export default Footer;
